import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid } from '@mui/material'
import { DatePicker } from '@e3dc-react/shell/Elements/InputFields'
import moment from '@e3dc-react/shell/Libs/moment'
import { useFormikContext } from 'formik'
import { ExportChargingCardFormData } from './ExportChargingCardEditor'

const ExportChargingCardDateRangeTab = (): JSX.Element => {
  const { t } = useCustomTranslation()
  const { setFieldValue, values, errors } = useFormikContext<ExportChargingCardFormData>()

  return (
    <Grid container paddingY={2} spacing={1}>
      <Grid item xs={6}>
        <DatePicker
          helperText={errors.from}
          value={moment(values.from)}
          label={t('emobility.chargingCards.export.startDate')}
          format={t('emobility.chargingCards.export.formatDateRange')}
          onChange={value => setFieldValue('from', value ? value.toDate() : null)}
          clearable={false}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          helperText={errors.to}
          value={moment(values.to)}
          label={t('emobility.chargingCards.export.endDate')}
          format={t('emobility.chargingCards.export.formatDateRange')}
          onChange={value => setFieldValue('to', value ? value.toDate() : null)}
          clearable={false}
        />
      </Grid>
    </Grid>
  )
}

export default ExportChargingCardDateRangeTab
